module.exports = __webpack_public_path__ + "img/Jini.73b94b97.png";